import React from 'react';
import { Button, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getName } from 'i18n-iso-countries';
import ModalComponent from './ModalComponent';
import Translate, { translate } from '../../i18n/Translate';
import notVerifiedUser from '../../views/Pages/Investment/components/SignInvestmentModal/signAgreement.svg';

const QualificationRequiredModal = ({
  onToggle,
  isOpen,
  activeLanguage,
  countryCode,
}) => (
  <ModalComponent
    title={translate('Texts.qualification-required')}
    image={notVerifiedUser}
    isOpen={isOpen}
    onToggle={onToggle}
    name="QualificationRequired"
  >
    <p className="modal-text font-16 m-0 text-center">
      <Translate
        translationKey="Texts.qualification-description"
        parameters={{ country: getName(countryCode, activeLanguage) }}
      />
    </p>
    <ModalFooter className="border-0 p-0 flex-column mb-2">
      <Button
        id="btn-got-it"
        className="m-0 issuer-primary"
        color="link"
        size="lg"
        block
        onClick={onToggle}
      >
        <Translate translationKey="Texts.got-it" />
      </Button>
    </ModalFooter>
  </ModalComponent>
);

QualificationRequiredModal.propTypes = {
  onToggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  activeLanguage: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
};

const mapStateToProps = ({ i18n, auth }) => ({
  activeLanguage: i18n.activeLanguage,
  countryCode: auth.user.countryCode,
});

export default connect(mapStateToProps)(QualificationRequiredModal);
